module.exports = __webpack_public_path__ + "static/img/5.2e20cff5.png";